import { RulesOutcomeComparisons } from "@/models/business-rules/RulesOutcomeComparisons";

export const rulesOutcomeComparisons: RulesOutcomeComparisons[] = [
  {
    id: 1,
    alias: "lesser_of",
    readable_name: "lesser of"
  },
  {
    id: 3,
    alias: "equal_to",
    readable_name: "equal to"
  },
  {
    id: 5,
    alias: "greater_of",
    readable_name: "greater of"
  },
  {
    id: 7,
    alias: "midpoint",
    readable_name: "midpoint"
  }
];
